module.exports = __webpack_public_path__ + "img/mall02.d7b1027a.png";